import { Box } from "@mui/material";

function PdfIcon({ sx = {} }) {
    return (
        <Box
            component={"svg"}
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            sx={{
                ...sx,
            }}
        >
            <defs>
                <clipPath id="clip0">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
            <g clipPath="url(#clip0)">
                <path d="M4 0H21L30 9V30C30 31.105 29.105 32 28 32H4C2.895 32 2 31.105 2 30V2C2 0.895 2.895 0 4 0Z" fill="#E2574C" />
                <path d="M30 9H23C21.895 9 21 8.105 21 7V0L30 9Z" fill="#B53629" />
                <path
                    d="M22.5 15.163C22.833 15.163 23 14.871 23 14.588C23 14.295 22.826 14.012 22.5 14.012H20.59C20.217 14.012 20.009 14.321 20.009 14.662V19.351C20.009 19.769 20.247 20.001 20.569 20.001C20.889 20.001 21.128 19.769 21.128 19.351V18.064H22.282C22.64 18.064 22.819 17.771 22.819 17.48C22.819 17.195 22.64 16.912 22.282 16.912H21.128V15.163H22.5ZM16.049 14.012H14.653C14.274 14.012 14.005 14.272 14.005 14.658V19.355C14.005 19.834 14.392 19.984 14.669 19.984H16.134C17.868 19.984 19.013 18.843 19.013 17.082C19.012 15.22 17.934 14.012 16.049 14.012ZM16.116 18.826H15.265V15.17H16.032C17.193 15.17 17.698 15.949 17.698 17.024C17.698 18.03 17.202 18.826 16.116 18.826ZM11.002 14.012H9.619C9.228 14.012 9.01 14.27 9.01 14.662V19.351C9.01 19.769 9.26 20.001 9.596 20.001C9.932 20.001 10.182 19.769 10.182 19.351V17.982H11.049C12.119 17.982 13.002 17.224 13.002 16.005C13.002 14.812 12.15 14.012 11.002 14.012ZM10.979 16.882H10.182V15.113H10.979C11.471 15.113 11.784 15.497 11.784 15.998C11.783 16.498 11.471 16.882 10.979 16.882Z"
                    fill="white"
                />
            </g>
        </Box>
    );
}

export default PdfIcon;
